/**
 * Регион, закреплённый за текущим origin в BOT_MAP. null — в браузерной PWA
 * и у главного бота MAX: там регион выбирает человек.
 */
export function getRegionByOrigin(
  origin: string = window.location.origin
): { regionFias: string; regionName: string } | null {
  const found = window.__CONFIG__?.botMap?.find(
    (item) => item.origin === origin
  );

  if (!found?.regionFias || !found?.regionName) return null;

  return { regionFias: found.regionFias, regionName: found.regionName };
}
